<div class="margin-bottom-5">
  @if (uiConfiguration.showOriginalQCFormTypeID) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.originalFormType' | transloco }}</span>
      <span class="flex-item-4" data-testid="original-form-type-text">{{ referenceRegistrationDetails?.originalQCFormTypeID?.toString() }}</span>
    </div>
  }
  @if (uiConfiguration.showOriginalOrderTypeID) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.originalRegistrationType' | transloco }}</span>
      <span class="flex-item-4" data-testid="original-registration-type-text">{{ formatOriginalOrderType($safeNavigationMigration(referenceRegistrationDetails?.originalOrderTypeID)) }}</span>
    </div>
  }
  @if (uiConfiguration.showOriginalSigningDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.originalSigningDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="original-signing-date-text">{{ $safeNavigationMigration(referenceRegistrationDetails?.originalSigningDate) | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>
  }
  @if (uiConfiguration.showFileNumber && order.lien?.fileNumber) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.fileNumber2' | transloco }}</span>
      <span class="flex-item-4" data-testid="file-number-text">{{ order.lien?.fileNumber }}</span>
    </div>
  }
  @if (uiConfiguration.showRegistrationNumber) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.registrationNumber2' | transloco }}</span>
      <span class="flex-item-4" data-testid="registration-number-text">{{ referenceRegistrationDetails?.registrationNumber ?? referenceRegistrationDetails?.originalRegistrationNumber }}</span>
    </div>
  }
  @if (uiConfiguration.showOriginalRegistrationNumber) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.originalRegistrationNumber' | transloco }}</span>
      <span class="flex-item-4" data-testid="original-registration-number-text">{{ referenceRegistrationDetails?.originalRegistrationNumber }}</span>
    </div>
  }
  @if (uiConfiguration.showRIN) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.rin' | transloco }}</span>
      <span class="flex-item-4" data-testid="rin-text">{{ referenceRegistrationDetails?.rin ?? "NO RIN" }}</span>
    </div>
  }
  @if (uiConfiguration.showRegistrationDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.registrationDate2' | transloco }}</span>
      <span class="flex-item-4" data-testid="registration-date-text">{{ $safeNavigationMigration(referenceRegistrationDetails?.originalRegistrationDate) | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>
  }
  @if (uiConfiguration.showExpiryDate) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.currentExpiryDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="current-expiry-date-text">{{ (referenceRegistrationDetails?.expiryDate == null) ? "NO EXPIRY DATE" : $safeNavigationMigration(referenceRegistrationDetails?.expiryDate) | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>
  }
  @if (showCurrentExpiryDate()) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'existingRegistrationDetails.originalExpiryDate' | transloco }}</span>
      <span class="flex-item-4" data-testid="current-expiry-date-text">{{ (referenceRegistrationDetails?.originalExpiryDate == null) ? "NO EXPIRY DATE" : $safeNavigationMigration(referenceRegistrationDetails?.originalExpiryDate) | localizedDate: 'yyyy-MM-dd' }}</span>
    </div>
  }
</div>